//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { ComponentAccessUserService } from '../system/component-access/component-access-user-service';
import { ConfigSystemService } from '../system/config-system/config-system-service';
import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class DropdownService {

  private get _trackingCompanyIdIsOn() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownsTrackingCompanyId, false) &&
                                                this.componentAccessUserService.hasAccessGuid(AccessGuids.DropdownsTrackingCompanyId, true);     }

  private _trackerCompanyId: number | undefined;

  get trackerCompanyId   () { return this._trackingCompanyIdIsOn ?          this._trackerCompanyId       : undefined; }
  get trackerCompanyIdAbs() { return this._trackingCompanyIdIsOn ? Math.abs(this._trackerCompanyId ?? 0) : undefined; }

  set trackerCompanyId(trackerCompanyId: number | undefined ) { this._trackerCompanyId=this._trackingCompanyIdIsOn
                                                                ? ((trackerCompanyId===1 || trackerCompanyId===-1) ? undefined : trackerCompanyId)
                                                                : undefined; }
  
  constructor(
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService
  ) { }

  public trackingCompanyIdIsOn(): boolean {
    try {
      return this._trackingCompanyIdIsOn;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
}
